/**
 * The factory codes, and which one a reader lands on — one rule, shared, because two copies drift.
 * Codes are post-collapse: legacy folds PG / PGA / PGV / PGN into PGV in every query touching a
 * factory, so PGV is the only one of the four that reaches the API.
 */

import type { FilterOption } from '@/lib/filters';

export const FACTORY_OPTIONS: readonly FilterOption[] = [
  { value: 'BCA', label: 'BCA' },
  { value: 'BVG', label: 'BVG' },
  { value: 'BVN', label: 'BVN' },
  { value: 'BYS', label: 'BYS' },
  { value: 'PGV', label: 'PGV' },
];

export type FactoryCode = 'BCA' | 'BVG' | 'BVN' | 'BYS' | 'PGV';

const CODES: ReadonlySet<string> = new Set(FACTORY_OPTIONS.map((option) => option.value));

export function isFactoryCode(value: string | null | undefined): value is FactoryCode {
  return value !== null && value !== undefined && CODES.has(value);
}

/**
 * The factory a page is looking at: the URL, else the reader's login site, else the first code.
 * Always a real code — reports binding `= :factory` with no null-guard have no "all factories"
 * answer to fall back on, so there is no null case to represent.
 */
export function resolveFactory(
  fromUrl: string | null,
  loginFactory: string | null | undefined,
): FactoryCode {
  if (isFactoryCode(fromUrl)) {
    return fromUrl;
  }
  const login = (loginFactory ?? '').trim().toUpperCase();
  return isFactoryCode(login) ? login : 'BCA';
}
